import { useEffect } from 'react';
import Bugsnag, { isBugsnagEnabled } from '@lib/bugsnag';
import { useAuth } from '@lb-classroom/feature-auth';

const BugsnagUserSetter = (): null => {
  const { currentUser } = useAuth();

  useEffect(() => {
    if (!isBugsnagEnabled) return;

    if (currentUser) {
      Bugsnag.setUser(
        String(currentUser.id),
        currentUser.email,
        currentUser.first_name
          ? `${currentUser.first_name} ${currentUser.last_name || ''}`.trim()
          : undefined,
      );
    } else {
      Bugsnag.setUser(undefined, undefined, undefined);
    }
  }, [currentUser]);

  return null;
};

export default BugsnagUserSetter;
